module.exports = __webpack_public_path__ + "img/Kraftfahrzeug.5a8bd140.svg";